/* ============================================================
   AUTOLOGIN: guarda credenciales al registrarse y entra solo
   ============================================================ */

/* --- 1. Guardar datos al enviar el formulario de registro --- */
$(document).on("click", ".submit.wizard__submit", function () {
  var $form = $(this).closest("form[data-id]");
  if (!$form.length) return;

  var $tel = $form.find('input[name="phone"]');

  var email    = ($form.find('input[name="email"]').val() || "").trim();
  var password = $form.find('input[name^="password"]').val() || "";
  var telefono = ($tel.val() || "").trim();

  // Teléfono con indicativo (+57), que intl-tel-input guarda aparte
  if (window.intlTelInputGlobals && $tel.length) {
    var iti = window.intlTelInputGlobals.getInstance($tel[0]);
    if (iti && iti.getNumber()) telefono = iti.getNumber();
  }

  if (!email || !password) {
    console.warn("Autologin: datos incompletos, no se guarda.");
    return;
  }

  localStorage.setItem(
    "formDataCustom",
    JSON.stringify({ email: email, password: password, telefono: telefono })
  );
});

/* --- 2. Limpiar datos viejos al entrar a las páginas de registro --- */
(function () {
  var path = window.location.pathname.replace(/\/$/, "");
  if (path === "/account/register" || path === "/pages/registro") {
    localStorage.removeItem("formDataCustom");
  }
})();

/* --- 3. Autologin en /account/login --- */
(function () {
  var path = window.location.pathname.replace(/\/$/, "");
  if (path !== "/account/login") return;

  // NUEVO: si viene a recuperar la contraseña, no hay autologin y se borran los datos guardados
  if (window.location.hash === "#recover") {
    localStorage.removeItem("formDataCustom");
    return;
  }
  
  var raw = localStorage.getItem("formDataCustom");
  if (!raw) return;

  var data;
  try {
    data = JSON.parse(raw);
  } catch (e) {
    data = null;
  }

  if (!data || !data.email || !data.password) {
    localStorage.removeItem("formDataCustom");
    return;
  }

  // Tapa la pantalla para que no se vea el formulario de login
  var overlay = document.createElement("div");
  overlay.setAttribute(
    "style",
    "position:fixed;inset:0;z-index:99999;background:#fff;display:flex;" +
      "align-items:center;justify-content:center;font-size:20px;color:#333;" +
      "text-align:center;padding:20px;"
  );
  overlay.textContent = "Ingresando a tu cuenta...";
  document.documentElement.appendChild(overlay);

  function autoLogin() {
    var pwd = document.querySelector(
      'form[action*="/account/login"] input[name="customer[password]"]'
    );

    // Si no existe el campo, muestra la página normal
    if (!pwd) {
      overlay.remove();
      return;
    }

    var form = pwd.closest("form");
    form.querySelector('input[name="customer[email]"]').value = data.email;
    pwd.value = data.password;

    // Shopify redirige aquí tras autenticar
    var ret = document.createElement("input");
    ret.type = "hidden";
    ret.name = "return_url";
    ret.value = "/collections/all";
    form.appendChild(ret);

    // Webhook de Wati (no bloquea el envío)
    if (data.telefono) {
      try {
        navigator.sendBeacon(
          "https://sublimewoocommerce.store/dev/webwooks/wati/vuelve_registro.php?" +
            "email=" + encodeURIComponent(data.email) +
            "&telefono=" + encodeURIComponent(data.telefono)
        );
      } catch (e) {}
    }

    // Se borra ANTES de enviar: si falla, no hay bucle infinito
    localStorage.removeItem("formDataCustom");

    // Marca el registro para medirlo cuando el login sea exitoso
    try { sessionStorage.setItem('pendingRegistro', '1'); } catch (e) {}

    localStorage.removeItem("formDataCustom");

    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoLogin);
  } else {
    autoLogin();
  }
})();

/* ============================================================
   FUNCIONALIDAD ORIGINAL DEL TEMA
   ============================================================ */

/* Alternar entre login y recuperar contraseña 
$(document).on("click", ".login__toggle", function () {
  $(".login__reset").toggle();
  $(".login__form").toggle();
});*/

$(document).off("click.lt", ".login__toggle").on("click.lt", ".login__toggle", function () {
  $(".login__reset").toggle();
  $(".login__form").toggle();
});

/* Efecto parallax */
(function () {
  var rellax = function () {
    new Rellax(".rellax");
  };

  document.addEventListener("shopify:section:load", function () {
    rellax();
  });

  rellax();
})();

$(function () {
  function mostrarRecuperar() {
    if (location.hash === '#recover') {
      $('.login__reset').show();
      $('.login__form').hide();
    }
  }
  mostrarRecuperar();
  $(window).off('hashchange.lt').on('hashchange.lt', mostrarRecuperar);
});



/* --- Recuperar contraseña con correo O celular --- */
$(function () {
  var ENDPOINT = 'https://sublimewoocommerce.store/dev/webwooks/wati/shopify/recuperar.php';

  // Textos del formulario
  $('#recover .page-header__inner p').text('Ingresa tu correo o tu WhatsApp para recuperar tu cuenta.');
  $('#RecoverEmail').attr({ type: 'text', placeholder: 'Correo o número de WhatsApp', inputmode: 'email' });
  $('label[for="RecoverEmail"]').attr('placeholder', 'Correo o número de WhatsApp');   // NUEVO

  function mensaje() {
    var $m = $('#recover-msg');
    if (!$m.length) {
      $m = $('<p id="recover-msg" style="margin-top:12px;font-size:14px;"></p>')
        .insertAfter($('form[action="/account/recover"]'));
    }
    return $m;
  }

  $(document).off('submit.rec').on('submit.rec', 'form[action="/account/recover"]', function (e) {
    e.preventDefault();   // nunca se recarga la página: correo y celular van por el servidor

    var $form = $(this);
    var valor = ($('#RecoverEmail').val() || '').trim();
    var $msg  = mensaje();

    if (!valor) { $msg.text('Ingresa tu correo o celular.'); return; }

    var $btn = $form.find('[type="submit"]').prop('disabled', true);
    $msg.text('Buscando tu cuenta...');

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },   // evita la petición previa de CORS
      body: JSON.stringify({ valor: valor })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.ok) {
          $msg.text('Enviamos el link para restablecer tu contraseña al correo ' + d.correo + '. Revisa también la carpeta de spam.');
        } else if (d.error === 'no_encontrado') {
          $msg.text('No encontramos una cuenta con ese dato. Revisa que esté bien escrito.');
        } else if (d.error === 'correo_invalido' || d.error === 'telefono_invalido') {
          $msg.text('Escribe un correo o un celular válido.');
        } else if (d.error === 'limite') {
          $msg.text('Demasiados intentos. Espera un rato e inténtalo de nuevo.');
        } else {
          $msg.text('No pudimos enviar el link. Inténtalo de nuevo en unos minutos.');
        }
      })
      .catch(function () { $msg.text('No pudimos conectar. Inténtalo de nuevo.'); })
      .then(function () { $btn.prop('disabled', false); });
  });
});